import React, { lazy } from 'react';
export function ArticleHeader() {
  return <div className="flex flex-col" style={{
    fontFamily: 'Figtree, sans-serif'
  }} data-id="element-163">
      {/* Logo + Advertorial */}
      <div className="flex items-end justify-between" data-id="element-164">
        <img src="https://cdn.magicpatterns.com/patterns/figma-images/66g1a0V3VBLDEJqj7q2Lq0/4161-842.png" alt="MaleUp Logo" style={{
        width: 200,
        height: 63
      }} data-id="element-165" />
        <span style={{
        fontSize: 11,
        fontWeight: 300,
        color: '#999999',
        letterSpacing: '0.5px',
        marginBottom: 2
      }} data-id="element-166">
          Advertorial
        </span>
      </div>

      {/* Headline */}
      <h1 className="font-medium" style={{
      fontSize: 28,
      lineHeight: '36px',
      color: '#003366',
      maxWidth: 876,
      marginTop: 14
    }} data-id="element-167">
        Warum werden Falten bei Männern ab 40 plötzlich viel schlimmer und was
        kann man dagegen tun?
      </h1>

      {/* Subtitle */}
      <p className="font-bold" style={{
      fontSize: 18,
      lineHeight: '26px',
      color: '#16283B',
      maxWidth: 783,
      marginTop: 12
    }} data-id="element-168">
        <mark style={{
        backgroundColor: '#ff9900',
        color: '#16283B'
      }} data-id="element-169">
          Du willst wissen warum dein Gesicht in den letzten Jahren so viel
          müder und älter aussieht, als du dich fühlst...
        </mark>{' '}
        Dieser Artikel verrät dir die Wissenschaft dahinter und zeigt dir eine
        unbekannte Lösung, die tausende Männer bereits nutzen.
      </p>

      {/* Hero Image */}
      <img src="https://maleup.de/cdn/shop/files/man_skin_WD40_1.gif?v=1773413413&width=720" alt="" className="rounded" loading="lazy" style={{
      marginTop: 27
    }} data-id="element-170" />

      {/* Author Row */}
      <div className="flex items-center gap-3" style={{
      marginTop: 27
    }} data-id="element-171">
        <img src="https://cdn.magicpatterns.com/patterns/figma-images/66g1a0V3VBLDEJqj7q2Lq0/4161-1174.png" alt="Sven Elsberger" className="rounded-full" style={{
        width: 50,
        height: 50
      }} data-id="element-172" />
        <div className="flex flex-col" data-id="element-173">
          <div className="flex items-center gap-2" data-id="element-174">
            <span className="font-bold" style={{
            fontSize: 16,
            lineHeight: '22px',
            color: '#16283B'
          }} data-id="element-175">
              von Sven Elsberger
            </span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Verified" data-id="element-176">
              <circle cx="12" cy="12" r="12" fill="#2991F0" data-id="element-177" />
              <path d="M7.5 12.5L10.5 15.5L16.5 9.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-178" />
            </svg>
          </div>
          <span className="font-light" style={{
          fontSize: 13,
          lineHeight: '18px',
          color: '#575757'
        }} data-id="element-179">
            Chefredakteur von Dermablog
          </span>
        </div>
        <span style={{
        fontSize: 14,
        lineHeight: '20px',
        color: '#575757',
        marginLeft: 'auto'
      }} data-id="element-180">
          24. März 2026
        </span>
      </div>
    </div>;
}